<template>
    <!-- Carousel slide selector/picker -->
    <div class="w-full flex gap-4 justify-center flex-wrap">
       <button
      v-for="i in slideCount"
      :key="i"
      :aria-label="'Go to slide ' + i"
      :aria-current="currentSlide === i"
      role="tab"
      :aria-selected="currentSlide === i"
      @click="$emit('onSelectSlide', i)"
      @keydown="onKeydown($event, i)"
    >
            <Icon icon='circle' :class="contentCarouselTabStyle(i)"/>
        </button>
    </div>
</template>

<script setup lang="ts">
import Icon from '../../atom/icon.vue';

interface CarouselSlideSelectorProps {
    slideCount: number;
    currentSlide: number;
    theme?: "DARK" | "LIGHT";
}

const {slideCount=1, currentSlide, theme="LIGHT"} = defineProps<CarouselSlideSelectorProps>()

const emits = defineEmits(['onSelectSlide']);

const contentCarouselTabStyle = (slideNum:number) => {
    return {
        'text-gray-300 text-opacity-50': currentSlide !== slideNum,
        'text-white': currentSlide === slideNum && theme === 'DARK',
        'text-black': currentSlide === slideNum && theme === 'LIGHT',
    };
}
function onKeydown(event: KeyboardEvent, index: number) {
  const buttons = (event.currentTarget as HTMLElement)
    .parentElement?.querySelectorAll<HTMLButtonElement>('button')
  if (!buttons) return

  const currentIndex = index - 1

  if (event.key === 'ArrowRight') {
    const nextIndex = (currentIndex + 1) % buttons.length
    buttons[nextIndex]!.focus()
  } else if (event.key === 'ArrowLeft') {
    const prevIndex = (currentIndex - 1 + buttons.length) % buttons.length
    buttons[prevIndex]!.focus()
  }
}

</script>